import React, { useState } from "react";
import { Collapse, Panel } from "react-bootstrap";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";

import './styles.scss';

const PanelTabWrapper = ({
    title,
    children,
    styles = null,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Panel style={{ flex: 1, ...styles }}>
            <PanelHeading
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                onClick={() => setIsOpen(status => !status)}
            >
                <PanelTitle>{title}</PanelTitle>
                <span className={`panel-tab-wrapper-icon ${isOpen ? 'open' : ''}`} />
            </PanelHeading>
            <Collapse in={isOpen}>
                <PanelBody>
                    {children}
                </PanelBody>
            </Collapse>
        </Panel>
    );
};

export default PanelTabWrapper;